module.exports = __webpack_public_path__ + "img/cs-protrain-4.7fe275d3.jpg";